import React from "react";
import {
  FaCalendarAlt,
  FaChartPie,
  FaClipboardList,
  FaClock,
  FaCoins,
  FaCreditCard,
  FaDolly,
  FaFileInvoiceDollar,
  FaInfoCircle,
  FaMapMarkerAlt,
  FaPassport,
  FaPlusCircle,
  FaShieldAlt,
  FaShip,
  FaTasks,
  FaTruck,
  FaUser,
  FaWarehouse,
} from "react-icons/fa";

const ICONS = {
  rfqSummary: FaClipboardList,
  provider: FaUser,
  quote: FaFileInvoiceDollar,
  basicInfo: FaInfoCircle,
  vesselTimeline: FaShip,
  coreCharges: FaCoins,
  loadingUnloading: FaDolly,
  additionalServices: FaPlusCircle,
  cargoInsurance: FaShieldAlt,
  customsClearance: FaPassport,
  warehousing: FaWarehouse,
  pickup: FaTruck,
  delivery: FaMapMarkerAlt,
  freeTimeDetention: FaClock,
  paymentTerms: FaCreditCard,
  quoteSummary: FaChartPie,
  checklist: FaTasks,
  calendar: FaCalendarAlt,
};

export default function LogisticsQuoteSectionIcon({ name, className = "lq-section-icon" }) {
  const Icon = ICONS[name];
  if (!Icon) return null;
  return <Icon className={className} aria-hidden />;
}
